import React, { useEffect, useState } from "react";
import AdminLayout from "@/components/AdminLayout";
import { adminAnalytics, adminDownloadCohortCsv } from "@/lib/api";
import { FileDown } from "lucide-react";

function Stat({ label, value }) {
  return <div className="rbl-card" style={{ alignItems: "flex-start" }}>
    <span className="rbl-card-num">{label}</span>
    <span style={{ fontSize: 32, fontWeight: 800, color: "var(--navy)" }}>{value}</span>
  </div>;
}

export default function AdminAnalytics() {
  const [d, setD] = useState(null);
  useEffect(() => { adminAnalytics().then(setD).catch(() => {}); }, []);
  if (!d) return <AdminLayout><div className="rbl-spinner" /></AdminLayout>;
  return (
    <AdminLayout>
      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <h1 className="rbl-h1" style={{ fontSize: 34 }}>Analytics</h1>
        <button className="rbl-btn" onClick={adminDownloadCohortCsv} data-testid="export-csv"><FileDown size={16} /> Export cohort progress (CSV)</button>
      </div>
      <div className="rbl-stat-grid" style={{ marginTop: 18 }} data-testid="analytics-stats">
        <Stat label="PARTICIPANTS" value={d.participants} />
        <Stat label="LOGGED IN" value={d.logged_in} />
        <Stat label="DID A WORKSHEET" value={d.did_a_worksheet} />
        <Stat label="DID A QUIZ" value={d.did_a_quiz} />
        <Stat label="REFLECTIONS" value={d.total_reflections} />
      </div>
      <h2 className="rbl-section-title" style={{ marginTop: 32 }}>Quiz performance</h2>
      <div className="rbl-table-wrap">
        <table className="rbl-table">
          <thead><tr><th>Quiz</th><th>Attempts</th><th>Avg score</th></tr></thead>
          <tbody>
            {d.quiz_stats.map((q, i) => <tr key={i}><td>{q.title}</td><td>{q.attempts}</td><td>{q.avg_score}%</td></tr>)}
            {d.quiz_stats.length === 0 && <tr><td colSpan={3} style={{ color: "var(--muted)" }}>No attempts yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
